<!--
 - Author : 003.
 - Date   : 2019/5/31.
 - File   : peicLeader.今日陪餐领导d
 -->

<template>
  <div class="peic-leader">
    <layer title="" padding="10px 20px" :contPadding="state===1?'3px 0':'3px 100px'" class="peic-leader" width="440px">
      <el-row class="leader">
        <el-col :span="12">
          <!--          <liquid-fill id="safeFill11" :liquid-list="safeFillData"></liquid-fill>-->
          <custom-dashboard id="dashboard" :dashboardObj="safeDashboardObj"></custom-dashboard>
        </el-col>
        <el-col :span="12">
          <el-row class="leader" v-if="state===1">
            <el-col :span="10">
              <div class="leader-img">
                <img :src="leader.avatar?(imgUrl + leader.avatar):avatar" alt="">
              </div>
            </el-col>
            <el-col :span="14" class="leader-info">
              <p>
                <span class="position">{{ leader.userName || '暂无' }}</span>
                <span class="name">{{ leader.postName || '暂无职位' }}</span>
              </p>
              <p>今日陪餐领导</p>
            </el-col>
          </el-row>
          <!--<div>
            <p :class="['cbs',state===1?'':'cbs-dis']">共有运营商
              <span :class="['cbs-num',state===1?'':'cbs-dis1']"><span>{{ total }}</span>家</span>
            </p>
          </div>-->
        </el-col>

      </el-row>
    </layer>
  </div>
</template>

<script>
import customDashboard from '../echarts/customDashboard'

export default {
  name: 'peicLeader',
  components: {customDashboard},
  data() {
    return {
      deptId: this.$route.query.deptId,
      imgUrl: this.$store.getters.fileApi,
      avatar: require('../../assets/images/avatar.jpg'),
      leader: {},
      safeFillData: {
        date: 0,
        width: '81px',
        height: '81px',
        margin: '5px 16px',
        theTop: '50px',
        radius: '100%',
        bgColor: 'rgba(0,157,159,0.1)',
        borderColor: '#02536e',
        shadowColor: '#05575f',
        text: '安全指标',
        labelFontSize: 22,
        colorList: ['rgba(59,148,148,0.5)', 'rgba(5,87,95,0.7)', 'rgba(5,118,117,1)']
      },
      safeDashboardObj: {
        width: '180px',
        height: '180px',
        text: '',
        value: 0
      }
    }
  },
  props: {
    state: {
      default: 0,
      type: Number
    },
    total: {
      default: 0,
      type: Number
    }
  },
  mounted() {
    this.getExceptionLightTotal()
    this.getScheduleTodayLeadinfo()
    this.getSafetyIndex()
    window.getYCTotal = () => {
      this.getExceptionLightTotal()
      this.getSafetyIndex()
    }
  },
  methods: {
    /**
     * @description: 获取异常安全指数
     * @author: linwen linwen@fjxhx.com
     * @createDate: 2021-01-19 16:31
     */
    getSafetyIndex() {
      this.$request.exceptionSafetyindexScreenAppGet({
        orgId: this.$store.getters.userInfo.orgId,
        deptId: this.deptId
      }).then(res => {
        console.log('__安全预警__获取异常安全指数__获取异常安全指数__:', res);
        if (!this.$utils.isEmptyObject(res)) {
          this.safeDashboardObj.text = res.safetyIndex
          this.safeDashboardObj.value = res.score
        }
      })
    },
    /**
     * 获取今日陪餐领导人
     * @author wanghongling
     * @createTime 2019/07/03
     */
    getScheduleTodayLeadinfo() {
      this.$request.accompanyScheduleTodayLeadinfo({departmentId: this.deptId}).then(res => {
        console.log('获取今日陪餐领导人', res)
        if (!this.$utils.isEmptyObject(res)) {
          this.leader = res
        }
      }).catch(e => {
        console.error(e)
      })
    },
    /**
     * 获取指示灯异常总数
     * @author wanghongling
     * @createTime 2019/07/03
     */
    getExceptionLightTotal() {
      this.$request.exceptionLightTotalGet({departmentId: this.deptId}).then(res => {
        console.log('获取指示灯异常总数', res)
        this.safeFillData.date = res
      }).catch(e => {
        console.error(e)
      })
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less">
@import '../../assets/less/color';

.peic-leader {
  .green {
    color: @green;
  }

  .yellow {
    color: @yellow;
  }

  .leader {
    display: flex;
    align-items: center;

    .cbs {
      color: @darkBlue;
      font-size: 15px;
      text-align: center;
    }

    .cbs-num {
      font-size: 16px;
      color: #00fffc;
      text-align: center;

      span {
        font-size: 20px;
        padding: 0 5px;
      }
    }

    .cbs-dis {
      display: inline-block;
    }

    .cbs-dis1 {
      display: inline-block;
      padding-left: 22px;

      span {
        font-size: 25px !important;
      }
    }

    &-right {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      color: #00fffc;

      &-item {
        width: 50%;
        text-align: center;
        padding-bottom: 8px;
        font-size: 14px;

        .number {
          font-weight: bold;
          font-size: 20px;
        }
      }
    }
  }

  .leader-img {
    width: 68px;
    height: 68px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    border-radius: 50%;

    img {
      width: 100%;
      border-radius: 50%;
    }
  }

  .leader-info {
    padding-left: 10px;

    p {
      margin-top: 10px;
      font-size: 14px;
      color: #fff;

      .position {
        font-size: 15px;
        color: @darkBlue;
      }

      .name {
        padding-left: 8px;
        font-size: 14px;
        color: @lightBlue;
      }
    }

    p:first-child {
      margin-top: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shitang/peicLeader.vue